function loadView(path) {
	return () => import(`../views/${path}`);
}

export default [
	{
		name: '_home',
		path: '/',
		redirect: 'facturas',
		// component: loadView('dashboard/index.vue'),
		meta: {
			title: 'Dashboard',
			icon: 'tachometer-alt',
			auth: {
				strict: false,
				roles: ['_BOSS']
			}
		}
	},
	/// //////////////////////
	// EMPRESAS
	/// //////////////////////
	{
		name: 'empresas',
		path: '/empresas',
		component: loadView('empresas/index.vue'),
		meta: {
			title: 'Empresas',
			icon: 'building',
			auth: {
				strict: false,
				roles: ['view.empresas', 'view.mine.empresas']
			},
			topbar: {
				buttons: [
					{
						text: 'Nueva empresa',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						url: { name: 'empresas_new' },
						auth: {
							strict: false,
							roles: ['add.empresas', 'add.mod.empresas']
						}
					}
				]
			}
		}
	},
	{
		name: 'empresas_new',
		path: '/empresas/nueva',
		component: loadView('empresas/add/index.vue'),
		meta: {
			title: 'Nueva empresa',
			icon: 'building',
			auth: {
				strict: false,
				roles: ['add.empresas', 'add.mod.empresas']
			},
			topbar: {
				buttons: [
					{
						text: 'Todas las empresas',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						url: { name: 'empresas' },
						auth: {
							strict: false,
							roles: ['view.empresas', 'view.mine.empresas']
						}
					}
				]
			}
		}
	},
	{
		name: 'empresa',
		path: '/empresa/:id',
		component: loadView('empresas/view/index.vue'),
		meta: {
			title: 'Ficha de empresa',
			icon: 'building',
			auth: {
				strict: false,
				roles: ['view.empresas', 'view.mine.empresas']
			},
			topbar: {
				buttons: [
					{
						text: 'Todas las empresas',
						icon: 'plus-square',
						variant: '',
						class: '',
						url: { name: 'empresas' },
						auth: {
							strict: false,
							roles: ['view.empresas', 'view.mine.empresas']
						}
					},
					{
						text: 'Nueva empresa',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						url: { name: 'empresas_new' },
						auth: {
							strict: false,
							roles: ['add.empresas', 'add.mod.empresas']
						}
					}
				]
			}
		}
	},
	/// //////////////////////
	// PRODUCTOS
	/// //////////////////////
	{
		name: 'productos',
		path: '/productos',
		component: loadView('productos/index.vue'),
		meta: {
			title: 'Productos',
			icon: 'box-open',
			auth: {
				strict: true,
				roles: ['view.productos', 'add.productos']
			},
			topbar: {
				buttons: [
					{
						text: 'Nuevo producto',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						event: 'newProducto',
						auth: {
							strict: false,
							roles: ['add.productos', 'add.mod.productos']
						}
					}
				]
			}
		}
	},
	/// //////////////////////
	// SERIES
	/// //////////////////////
	{
		name: 'series',
		path: '/series',
		component: loadView('series/index.vue'),
		meta: {
			title: 'Series',
			icon: 'qrcode',
			auth: {
				strict: true,
				roles: ['view.series', 'add.series']
			},
			topbar: {
				buttons: [
					{
						text: 'Nueva serie',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						event: 'newSerie',
						auth: {
							strict: false,
							roles: ['add.series', 'add.mod.series']
						}
					}
				]
			}
		}
	},
	/// //////////////////////
	// FACTURAS
	/// //////////////////////
	{
		name: 'facturas',
		path: '/facturas',
		component: loadView('facturas/index.vue'),
		meta: {
			title: 'Facturas',
			icon: 'file-invoice',
			auth: {
				strict: false,
				roles: ['view.facturas', 'view.mine.facturas']
			},
			topbar: {
				buttons: [
					{
						text: 'Nueva factura',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						url: { name: 'facturas_new' },
						auth: {
							strict: false,
							roles: ['add.facturas', 'add.mod.facturas']
						}
					}
				]
			}
		}
	},
	{
		name: 'facturas_new',
		path: '/facturas/nueva',
		component: loadView('facturas/form/index.vue'),
		meta: {
			title: 'Nueva Factura',
			icon: ['fas', 'file-invoice'],
			auth: {
				strict: false,
				roles: ['add.facturas', 'add.mod.facturas']
			},
			topbar: {
				buttons: [{
					text: 'Todas las Facturas',
					icon: ['far', 'plus-square'],
					variant: 'primary',
					class: '',
					url: { name: 'facturas' },
					auth: {
						strict: false,
						roles: ['view.facturas', 'view.mine.facturas']
					}
				}]
			}
		}
	},
	{
		name: 'facturas_edit',
		path: '/facturas/:id',
		component: loadView('facturas/form/index.vue'),
		meta: {
			title: 'Modificar Factura',
			icon: ['fas', 'file-invoice'],
			auth: {
				strict: false,
				roles: ['set.facturas', 'set.mine.facturas']
			},
			topbar: {
				buttons: [{
					text: 'Todas los Facturas',
					icon: ['far', 'plus-square'],
					variant: 'primary',
					class: '',
					url: { name: 'facturas' },
					auth: {
						strict: false,
						roles: ['view.facturas', 'view.mine.facturas']
					}
				}]
			}
		}
	},
	/// //////////////////////
	// PRESUPUESTOS
	/// //////////////////////
	{
		name: 'presupuestos',
		path: '/presupuestos',
		component: loadView('presupuestos/index.vue'),
		meta: {
			title: 'Presupuestos',
			icon: 'receipt',
			auth: {
				strict: false,
				roles: ['view.presupuestos', 'view.mine.presupuestos']
			},
			topbar: {
				buttons: [
					{
						text: 'Nuevo presupuesto',
						icon: 'plus-square',
						variant: 'primary',
						class: '',
						url: { name: 'presupuestos_new' },
						auth: {
							strict: false,
							roles: ['add.presupuestos', 'add.mod.presupuestos']
						}
					}
				]
			}
		}
	},
	{
		name: 'presupuestos_new',
		path: '/presupuestos/nuevo',
		component: loadView('presupuestos/form/index.vue'),
		meta: {
			title: 'Nuevo Presupuesto',
			icon: ['fas', 'receipt'],
			auth: {
				strict: false,
				roles: ['add.presupuestos', 'add.mod.presupuestos']
			},
			topbar: {
				buttons: [{
					text: 'Todos los presupuestos',
					icon: ['far', 'plus-square'],
					variant: 'primary',
					class: '',
					url: { name: 'presupuestos' },
					auth: {
						strict: false,
						roles: ['view.presupuestos', 'view.mine.presupuestos']
					}
				}]
			}
		}
	},
	{
		name: 'presupuestos_edit',
		path: '/presupuestos/:id',
		component: loadView('presupuestos/form/index.vue'),
		meta: {
			title: 'Modificar Presupuesto',
			icon: ['fas', 'receipt'],
			auth: {
				strict: false,
				roles: ['set.presupuestos', 'set.mine.presupuestos']
			},
			topbar: {
				buttons: [{
					text: 'Todos los Presupuestos',
					icon: ['far', 'plus-square'],
					variant: 'primary',
					class: '',
					url: { name: 'presupuestos' },
					auth: {
						strict: false,
						roles: ['view.presupuestos', 'view.mine.presupuestos']
					}
				}]
			}
		}
	},
	/// //////////////////////
	// CONFIG
	/// //////////////////////
	{
		name: '_config',
		path: '/configuracion',
		component: loadView('_config.vue'),
		meta: {
			title: 'Configuración',
			icon: ['fas', 'wrench'],
			auth: {
				strict: false,
				roles: ['_BOSS']
			}
		}
	}
];
